<ng-container *appIfIsMobile>
  <div *ngIf="position.isMobile" class="search-filters-mobile">
    <form [formGroup]="searchFormGroup.searchForm">
      <div class="row font-size-0-96rem mx-1-75rem mb-0-35rem">
        <div class="col-12 px-0">
          <input ngbAutofocus type="hidden"/>

          <app-state-select
            *ngIf="countrySelected"
            [position]="position"
            [stateSelect]="stateSelect"
            [countrySelected]="countrySelected"
            [stateSelected]="stateSelected"
            (stateChange)="onStateChange($event)"
          ></app-state-select>

          <app-county-select
            *ngIf="stateSelected"
            [position]="position"
            [countySelect]="countySelect"
            [countySelected]="countySelected"
            [stateSelected]="stateSelected"
            (countyChange)="onCountyChange($event)"
          ></app-county-select>

          <app-region-select
            *ngIf="!regionSelect.isEmpty"
            [position]="position"
            [regionSelect]="regionSelect"
            [regionSelected]="regionSelected"
            [countySelected]="countySelected"
            (regionChange)="onRegionChange($event)"
          ></app-region-select>

          <app-city-select
            *ngIf="!citySelect.isEmpty"
            [position]="position"
            [citySelect]="citySelect"
            [citySelected]="citySelected"
            [countySelected]="countySelected"
            [regionSelected]="regionSelected"
            [stateSelected]="stateSelected"
            (cityChange)="onCityChange($event)"
          ></app-city-select>

          <app-district-select
            *ngIf="!districtSelect.isEmpty"
            [position]="position"
            [districtSelect]="districtSelect"
            [districtSelected]="districtSelected"
            [citySelected]="citySelected"
            [stateSelected]="stateSelected"
            (districtChange)="onDistrictChange($event)"
          ></app-district-select>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="position.asTitle" class="search-filters-mobile">
    <form [formGroup]="searchFormGroup.searchForm">
      <input ngbAutofocus type="hidden"/>

      <select
        #citySelectRef
        appAutoResizeSelect
        required
        aria-label="City"
        class="custom-select-navbar-title custom-select d-flex justify-content-center text-center hide-arrow w-100 border-0"
        style=" text-align-last: center; appearance: none;"
        formControlName="cityId"
        (change)="onCityChange($event.target)"
        [ngClass]="{'text-red': !citySelected}"
      >
        <option value="null" hidden [selected]="!citySelected">City</option>

        <ng-container *ngIf="countySelected">
          <ng-container *ngIf="citySelect.isGrouped">
            <ng-container *ngFor="let option of citySelect.options;">
              <option
                *ngIf="citySelectRef.value == option.value"
                class="custom-select-navbar-title"
                [value]="option.value"
              >
                {{ option.label }}
              </option>
            </ng-container>

            <option [value]="PickerCustomOption.EXPLORE_SEARCH">
              Search
            </option>

            <optgroup [label]="nearByLabel">
              <ng-container *ngFor="let option of citySelect.options;">
                <option
                  *ngIf="option.group == nearByLabel && citySelectRef.value != option.value"
                  [value]="option.value"
                >
                  {{ option.label }}
                </option>
              </ng-container>
            </optgroup>

            <optgroup [label]="otherLabel">
              <ng-container *ngFor="let option of citySelect.options">
                <option *ngIf="option.group == otherLabel" [value]="option.value">
                  {{ option.label }}
                </option>
              </ng-container>
            </optgroup>
          </ng-container>

          <ng-container *ngIf="!citySelect.isGrouped">
            <option *ngFor="let option of citySelect.options" [value]="option.value">
              {{ option.label }}
            </option>
          </ng-container>
        </ng-container>
      </select>
    </form>
  </div>
</ng-container>

<div *appIfIsDesktop class="search-filters-desktop">
  <form *ngIf="position.isDesktopNavbar && countrySelected" [formGroup]="searchFormGroup.searchForm">
    <div class="search-filters-desktop-under-logo row text-black">
      <app-state-select
        [position]="position"
        [stateSelect]="stateSelect"
        [countrySelected]="countrySelected"
        [stateSelected]="stateSelected"
        (stateChange)="onStateChange($event)"
      ></app-state-select>

      <app-county-select
        [position]="position"
        [countySelect]="countySelect"
        [countySelected]="countySelected"
        [stateSelected]="stateSelected"
        (countyChange)="onCountyChange($event)"
      ></app-county-select>

      <app-region-select
        [position]="position"
        [regionSelect]="regionSelect"
        [regionSelected]="regionSelected"
        [countySelected]="countySelected"
        (regionChange)="onRegionChange($event)"
      ></app-region-select>

      <app-city-select
        [position]="position"
        [citySelect]="citySelect"
        [citySelected]="citySelected"
        [countySelected]="countySelected"
        [regionSelected]="regionSelected"
        [stateSelected]="stateSelected"
        (cityChange)="onCityChange($event)"
      ></app-city-select>

      <app-district-select
        [position]="position"
        [districtSelect]="districtSelect"
        [districtSelected]="districtSelected"
        [citySelected]="citySelected"
        [stateSelected]="stateSelected"
        (districtChange)="onDistrictChange($event)"
      ></app-district-select>
    </div>
  </form>
</div>
